import { ysrLabel } from 'src/features/yellStory/drawer/labels/yellStory'
import { State } from 'src/types'
import { ysrEngravedOfCatchFace } from 'src/features/yellStory/drawer/labels/yellStory'
import {
  crossBackLace as crossBackLaceOfFront,
  straightBackLace as straightBackLaceOfFront
} from 'src/features/yellStory/drawer/glove/front/lace/backLace'

export const brandLabelDrawerForGlove = (ctx: CanvasRenderingContext2D, state: State): void => {
  ysrLabel(ctx, state.ysrLabel?.value, 0, 0)
}
// メーカー捕球面の刻印
export const engravedDrawer = (ctx: CanvasRenderingContext2D, catchFaceColor: string): void => {
  const engravedColor = ['black', 'navy', 'blue', 'chocolate'].includes(catchFaceColor) ? '#eee' : '#383838'
  ysrEngravedOfCatchFace(ctx, engravedColor)
}

export const backLaceDrawerOfFront = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLaceOfFront(ctx, laceColor, 0, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'crossAndStraight':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'cross':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      crossBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      crossBackLaceOfFront(ctx, laceColor, 225, -265, 30)
      return
    default:
      return
  }
}
